// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"350":"c10ef305","885":"24a944fd"}[chunkId] + ".css";
};